module.exports = __webpack_public_path__ + "img/ecosystem_01_solana2.baeb0016.png";